import { config, getSiteModule } from 'env_def';
import { CommonMailHostPlaceHolder, WebMailHostPlaceHolder } from '@/const';
import { host } from './urlConfig/url_common';
import { locationHelper } from '@/api/util/location_helper';
import { inWindowTool } from './utils/inWindow';
import { getOs as _getOs } from './utils/confOs';
const REDIRECT_URL_KEY = 'lx_redirect_url';
export const setJumpRedirectUrl = (url) => {
    try {
        if (url) {
            localStorage.setItem(REDIRECT_URL_KEY, url);
        }
    }
    catch (ex) {
        console.error('setJumpRedirectUrl error', ex);
    }
};
export const isValidRedirectUrl = (url) => {
    if (!url)
        return false;
    try {
        const urlInfo = new URL(url);
        return ['163.com', 'netease.com'].some(host => urlInfo.host.indexOf(host) !== -1);
    }
    catch (ex) {
        console.error('isValidRedirectUrl error', ex);
        return false;
    }
};
export const getJumpRedirectUrl = () => {
    try {
        const url = localStorage.getItem(REDIRECT_URL_KEY) || '';
        localStorage.removeItem(REDIRECT_URL_KEY);
        return url;
    }
    catch (ex) {
        console.error('getJumpRedirectUrl error', ex);
        return '';
    }
};
export { transferLocalDeviceToServerDevice, transferServerDeviceToLocalDevice, transferCWServiceDeviceInfoToLocalDevice, transferLocalDeviceToCWServerDevice, } from './utils/sec-device-transfer';
if (inWindowTool()) {
    if (!window.apiUtils) {
        window.apiUtils = {};
    }
    window.apiUtils.inWindow = inWindowTool;
}
export const getShouldInitMemoryDBInMainPage = () => process.env.BUILD_ISWEB && (locationHelper.isMainPage() || locationHelper.isJumpPage());
export const getIsMainPage = () => locationHelper.isMainPage();
const forElectron = config('build_for') === 'electron';
export const customerSysConfig = {};
export const environment = config('stage');
export const isTest = environment !== 'prod';
export const apis = {
    defaultApiImpl: config('dataHttpApi'),
    defaultDataStoreApiImpl: config('defaultDataStoreApiImpl'),
    defaultSystemApiImpl: config('defaultSystemApiImpl'),
    defaultEventApi: config('defaultEventApi'),
    defaultFileApi: config('defaultFileApi'),
    loginApiImpl: config('loginApiImpl'),
    contactApiImpl: config('contactApiImpl'),
    contactDbImpl: config('contactDbImpl'),
    mailApiImpl: config('mailApiImpl'),
    mailSignatureImplApi: config('mailSignatureImplApi'),
    mailTemplateImplApi: config('mailTemplateImplApi'),
    mailProductImplApi: config('mailProductImplApi'),
    newDbApiImpl: config('newDbApiImpl'),
    catalogApiImpl: config('catalogApiImpl'),
    icsApiImpl: config('icsApiImpl'),
    imTeamApiImpl: config('imTeamApiImpl'),
    imDiscussApiImpl: config('imDiscussApiImpl'),
    imApiImpl: config('imApiImpl'),
    pushApiImpl: config('pushApiImpl'),
    upgradeAppApiImpl: config('upgradeAppApiImpl'),
    mailConfApiImpl: config('mailConfApiImpl'),
    mailBlacklistApiImpl: config('mailBlacklistApiImpl'),
    netStorageImpl: config('netStorageImpl'),
    netStorageShareImpl: config('netStorageShareImpl'),
    errorReportImpl: config('errorReportImpl'),
    performanceImpl: config('performanceImpl'),
    dataTrackerApiImp: config('dataTrackerApiImp'),
    dexieDbApi: config('dexieDbApi'),
    dbCacheApiImpl: config('dbCacheApiImpl'),
    dbInterfaceApiImpl: config('dbInterfaceApiImpl'),
    dbMemoryApiImpl: config('dbMemoryApiImpl'),
    configSettingApiImpl: config('configSettingApiImpl'),
    htmlApi: config('htmlApi'),
    loggerApiImpl: config('loggerApiImpl'),
    taskApiImpl: config('taskApiImpl'),
    keyboardApiImpl: config('keyboardApiImpl'),
    kfApiImpl: config('kfApiImpl'),
    convertApiImpl: config('convertApiImpl'),
    registerApiImpl: config('registerApiImpl'),
    accountApiImpl: config('accountApiImpl'),
    taskCenterApiImpl: config('taskCenterApiImpl'),
    notificationCenterApiImpl: config('notificationCenterApiImpl'),
    approvalFlowApiImpl: config('approvalFlowApiImpl'),
    productAuthApiImpl: config('productAuthApiImpl'),
    mailStatusApiImpl: config('mailStatusApiImpl'),
    mailPraiseApiImpl: config('mailPraiseApiImpl'),
    mailDraftApiImpl: config('mailDraftApiImpl'),
    mailStrangerApiImpl: config('mailStrangerApiImpl'),
    autoReplyApiImpl: config('autoReplyApiImpl'),
    feedbackApiImpl: config('feedbackApiImpl'),
    edmSendBoxApiImpl: config('edmSendBoxApiImpl'),
    customerApiImpl: config('customerApiImpl'),
    edmRoleApiImpl: config('edmRoleApiImpl'),
    edmCustomsApiImpl: config('edmCustomsApiImpl'),
    fieldSettingApiImpl: config('fieldSettingApiImpl'),
    saleStageApiImpl: config('saleStageApiImpl'),
    globalSearchApiImpl: config('globalSearchApiImpl'),
    whatsAppApiImpl: config('whatsAppApiImpl'),
    insertWhatsAppApiImpl: config('insertWhatsAppApiImpl'),
    facebookApiImpl: config('facebookApiImpl'),
    snsMarketingApiImpl: config('snsMarketingApiImpl'),
    materielApiImpl: config('materielApiImpl'),
    aiStaffApiImpl: config('aiStaffApiImpl'),
    aiAsstWmApiImpl: config('aiAsstWmApiImpl'),
    customerDiscoveryApi: config('customerDiscoveryApi'),
    edmNotifyApiImpl: config('edmNotifyApiImpl'),
    autoMarketApiImpl: config('autoMarketApiImpl'),
    addressBookApiImpl: config('addressBookApiImpl'),
    addressBookNewApiImpl: config('addressBookNewApiImpl'),
    salesPitchApiImpl: config('salesPitchApiImpl'),
    mailPlusCustomerApiImpl: config('mailPlusCustomerApiImpl'),
    taskMailImplApi: config('taskMailImplApi'),
    webmailApiImpl: config('webmailApiImpl'),
    edmProductDataImpl: config('edmProductDataImpl'),
    advertApiImpl: config('advertApiImpl'),
    siteApiImpl: config('siteApiImpl'),
    aiHostingApiImpl: config('aiHostingApiImpl'),
    edmMenusApiImpl: config('edmMenusApiImpl'),
    ffmsApi: config('ffmsApi'),
    autoTestApi: config('autoTestApi'),
    globalGuideApiImpl: config('globalGuideApiImpl'),
    AddressBookNewApi: 'addressBookNewApiImpl',
    remindersImpl: config('remindersImpl'),
    aiAssistant: config('aiAssistant'),
    emptyApiImpl: 'emptyApi',
    agcOpApiImpl: config('agcOpApiImpl'),
    npsImpl: config('npsImpl'),
    safeBrowsingApiImpl: 'safeBrowsingApiImpl',
};
export const isElectron = () => process.env.BUILD_ISELECTRON;
export const getOs = _getOs;
export const globalAdSpaceCode = '188';
export const bannerSpaceCode = '166';
export const selectedAppsSpaceCode = '177';
export const edmWeeklyReportSpaceCode = '1222';
export const surveySpaceCode_dev = '13579';
export const surveySpaceCode_electron = '20230222';
export const surveySpaceCode_web_new = '2023021302';
export const surveySpaceCode_web_old = '20230221';
export const urlPrefixReplace = {
    hz: config('node_hz'),
    bj: config('node_bj'),
};
export const webMailURLPrefixReplace = {
    hz: config('webMailHZHost'),
    bj: config('webMailBJHost'),
};
export const deployContextPath = config('contextPath');
export const deployApiContextPath = config('apiContextPath');
const urlCacheMap = new Map();
const keyMap = {
    webSentry: 'sentryWebUrl',
    electronSentry: 'sentryElectronUrl',
    getLxSubMailNew: 'getLxSubMailNewColleauge',
    getSubMailNew: 'getSubMailNewColleauge',
    getYunxinInfoByEmail: 'getYunxinToken',
    listNSContent: 'listContent',
    listNSContentP: 'listContentP',
    listNSContentPS: 'listContentPS',
    listNSContentNumber: 'listContentNumber',
    listNSContentNumberP: 'listContentNumberP',
    listNSContentNumberPS: 'listContentNumberPS',
    getNSDirDetail: 'getDirDetail',
    getNSDirDetailP: 'getDirDetailP',
    getNSDirDetailPS: 'getDirDetailPS',
    getNSDirDetailFA: 'getDirDetailPS',
    getNSUploadToken: 'getUploadToken',
    getNSUploadTokenP: 'getUploadTokenP',
    getNSUploadTokenPS: 'getUploadTokenPS',
    getNSUploadTokenCA: 'getUploadTokenCA',
    renewNSUploadToken: 'renewUploadToken',
    renewNSUploadTokenP: 'renewUploadTokenP',
    renewNSUploadTokenPS: 'renewUploadTokenPS',
    getNSFileDetail: 'getFileDetail',
    getNSFileDetailP: 'getFileDetailP',
    getNSFileDetailPS: 'getFileDetailPS',
    getNSFileDetailFA: 'getFileDetailPS',
    delNSResource: 'delResource',
    delNSResourceP: 'delResourceP',
    delNSResourcePS: 'delResourcePS',
    createNSFolder: 'createFolder',
    createNSFolderP: 'createFolderP',
    createNSFolderPS: 'createFolderPS',
    moveNSResource: 'moveResource',
    moveNSDir: 'moveDir',
    moveNSResourceP: 'moveResourceP',
    moveNSResourcePS: 'moveResourcePS',
    downloadNSFileFA: 'downloadNSFilePS',
    etSupplierIncFastest: 'getSupplierIncFastest',
    corpStatsFolder: 'corpStatFolders',
    corpParseIcsFile: 'corpIcsParse',
    getAppUpgradeVersion: 'newUpgradeWeb',
};
const noHostKeys = ['sentryWebUrl', 'sentryElectronUrl', 'mailAttachmentUploadHost'];
const webmailHostKeys = [
    'getPwdRuleAfterLogin',
    'updatePwdAfterLogin',
    'mailOperation',
    'mailProxyOperation',
    'mailDownloadProxy',
    'mailDownload',
    'mailTraceStatus',
    'mailsReadStatus',
    'mailReadList',
    'entSignatureForMail',
    'getRiskReminderStatus',
    'updateRiskReminderStatus',
    'getMaillistMember',
    'createMaillist',
    'updateMaillist',
    'deleteMaillist',
    'listUserDomain',
    'listUserMaillist',
    'getMaillist',
    'getMaillistConfig',
    'checkMaillistAccountName',
    'readPack',
    'readPackProxy',
    'getFjFile',
    'getAntiSpamNotify',
    'updateAntiSpamNotify',
];
const webmailHostMap = {};
webmailHostKeys.forEach(item => {
    webmailHostMap[item] = true;
});
const noHostMap = {};
noHostKeys.forEach(item => {
    noHostMap[item] = true;
});
export const getUrlNew = (url) => {
    try {
        let ret;
        const urlKey = keyMap[url] ? keyMap[url] : url;
        if (urlCacheMap.has(urlKey)) {
            ret = urlCacheMap.get(urlKey);
        }
        else {
            const configUrl = noHostMap[urlKey]
                ? config(urlKey)
                : webmailHostMap[urlKey]
                    ? (WebMailHostPlaceHolder + config(urlKey))
                    : (host + config(urlKey));
            urlCacheMap.set(urlKey, configUrl);
            ret = configUrl;
        }
        return ret;
    }
    catch (ex) {
        console.error(ex);
        return '';
    }
};
export const getUrl = (url, currentNode) => {
    let ret = getUrlNew(url);
    if (!ret) {
        throw new Error('url config illegal:' + url);
    }
    if (ret.startsWith(WebMailHostPlaceHolder)) {
        if (forElectron &&
            isElectron() &&
            window.electronLib &&
            !window.apiResposity.getSystemApi().getProxyOn()) {
            const urlPrefixReplaceElement = webMailURLPrefixReplace[currentNode] || '';
            return ret
                .replace(WebMailHostPlaceHolder, urlPrefixReplaceElement)
                .replace(CommonMailHostPlaceHolder, '');
        }
        ret = ret.replace(WebMailHostPlaceHolder, host);
    }
    const urlPrefixReplaceElement = urlPrefixReplace[currentNode];
    const urlPrefix = forElectron && isElectron() ? '' : deployApiContextPath;
    const result = urlPrefix + ret.replace(CommonMailHostPlaceHolder, urlPrefixReplaceElement);
    return result;
};
export const getUrlPre = (url, currentNode) => {
    let ret = getUrlNew(url);
    if (!ret) {
        throw new Error('url config illegal:' + url);
    }
    if (ret.startsWith(WebMailHostPlaceHolder)) {
        if (forElectron &&
            isElectron() &&
            window.electronLib &&
            !window.apiResposity.getSystemApi().getProxyOn()) {
            return ret;
        }
        ret = ret.replace(WebMailHostPlaceHolder, host);
    }
    const urlPrefixReplaceElement = urlPrefixReplace[currentNode];
    const urlPrefix = forElectron && isElectron() ? '' : deployApiContextPath;
    const result = urlPrefix + ret.replace(CommonMailHostPlaceHolder, urlPrefixReplaceElement);
    return result;
};
export const getUrlFinal = (ret, currentNode) => {
    const urlPrefixReplaceElement = webMailURLPrefixReplace[currentNode] || '';
    return ret
        .replace(WebMailHostPlaceHolder, urlPrefixReplaceElement)
        .replace(CommonMailHostPlaceHolder, '');
};
export const externalJumpUrls = {
    bindNewPwd: config('bindNewPwd'),
    forgetPwd: config('forgetPwd'),
    prompt: config('prompt'),
};
export const contactDbInfo = {
    getTableName(usrSign) {
        return 'contactDb_' + (usrSign || 'all');
    },
    version: 1,
};
export const inWindow = inWindowTool;
export const isInMobile = () => {
    const ua = window.navigator.userAgent || window.navigator.vendor;
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(ua) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(ua.substr(0, 4))) {
        return true;
    }
    return false;
};
const contextPath = config('contextPath');
const profile = config('profile');
export const loginPage = config('loginPage');
export const mloginPage = config('mloginPage');
export const loginPageExt = (contextPath + config('loginPageExt'));
export const loginFlag = {
    canJump: true,
    needJump: false,
};
const logout = async () => {
    if (window.apiResposity.getSystemApi().getCurrentUser()) {
        const loginApi = window.apiResposity.requireLogicalApi(apis.loginApiImpl);
        await loginApi.doLogout(true, true);
    }
};
function buildLogoutPageUrl() {
    const isWebmail = profile && profile.startsWith('webmail');
    if (isWebmail) {
        return window.apiResposity.getDataTransApi().getLogoutPage();
    }
    return isInMobile() ? mloginPage : loginPage;
}
export const jumpLogin = (jumpConfig, callback) => {
    var _a;
    if (window.location.href.indexOf('init=true') > 0 && locationHelper.isMainPage()) {
        return;
    }
    const page = buildLogoutPageUrl();
    if (['/share/', '/doc/', '/sheet/'].some(path => location.href.indexOf(path) >= 0)) {
        logout()
            .then(() => {
            window.location.assign(page + '#' + encodeURIComponent(window.location.pathname + window.location.hash));
        })
            .catch(() => {
            window.location.assign(page + '#' + encodeURIComponent(window.location.pathname + window.location.hash));
        });
    }
    else if ((jumpConfig === null || jumpConfig === void 0 ? void 0 : jumpConfig.jumpTo) === 'setting' && isElectron() && window.electronLib) {
        (_a = window.apiResposity
            .getEventApi()
            .sendSysEvent({
            eventName: 'routeChange',
            eventData: {
                url: loginPageExt,
                state: Object.assign(Object.assign({ blocking: true }, (jumpConfig || {})), { currentTab: 'account' }),
                replace: true,
            },
            eventStrData: 'gatsbyStateNav',
            asInnerMsg: true,
        })) === null || _a === void 0 ? void 0 : _a.then(() => {
            if (callback) {
                callback();
            }
        });
    }
    else {
        if (inWindowTool() && environment !== 'prod' && window.isSizeChecker) {
            return;
        }
        logout()
            .then(() => {
            if (process.env.BUILD_ISEDM || process.env.BUILD_ISLINGHANG) {
                const isNewWebmail = isWebmail();
                if (!isNewWebmail) {
                    window.location.assign(page + `?redirect_url=${encodeURIComponent(window.location.href)}`);
                    return;
                }
                setJumpRedirectUrl(window.location.href);
            }
            window.location.assign(page);
        })
            .catch(() => {
            window.location.assign(page);
        });
    }
};
export const configKeyStore = {
    scheduleTabOpenInWindow: {
        type: 'localStorageKey',
        keyStr: 'scheduleTabOpenInWindow',
        valueType: 'bool',
    },
};
export const getPageName = () => {
    if (!inWindow()) {
        return '';
    }
    const currPagePath = location.pathname;
    let currPageName;
    if (currPagePath) {
        currPageName = currPagePath.replace(/\//g, '').replace('.html', '').toLowerCase();
    }
    return currPageName || 'index';
};
if (inWindow()) {
    window.apiUtils.getPageName = getPageName;
}
const noLoginPath = [];
noLoginPath.push('/about');
noLoginPath.push('/login');
noLoginPath.push('/mlogin');
noLoginPath.push('/share_anonymous');
noLoginPath.push('/password_reset');
noLoginPath.push('/compDoc');
noLoginPath.push('/launch');
noLoginPath.push('/kf');
noLoginPath.push('/api.html');
noLoginPath.push('/account-bg.html');
noLoginPath.push('/autoreply');
if (!String.prototype.replaceAll) {
    String.prototype.replaceAll = function (str, newStr) {
        if (Object.prototype.toString.call(str).toLowerCase() === '[object regexp]' && typeof newStr === 'string') {
            return this.replace(str, newStr);
        }
        if (typeof str === 'string' && typeof newStr === 'string') {
            return this.replace(new RegExp(str, 'g'), newStr);
        }
        if (typeof newStr === 'function') {
            console.warn('what the hell for using such function in a so old browser');
        }
        throw new Error('not support from polyfill');
    };
}
Promise.allSettled =
    Promise.allSettled ||
        function (arr) {
            return new Promise((resolve, reject) => {
                if (Object.prototype.toString.call(arr) !== '[object Array]') {
                    return reject(new TypeError(typeof arr + ' ' + arr + ' ' + ' is not iterable(cannot read property Symbol(Symbol.iterator))'));
                }
                const args = Array.prototype.slice.call(arr);
                if (args.length === 0)
                    return resolve([]);
                let arrCount = args.length;
                function resolvePromise(index, value) {
                    if (typeof value === 'object') {
                        const { then } = value;
                        if (typeof then === 'function') {
                            then.call(value, function (val) {
                                args[index] = { status: 'fulfilled', value: val };
                                arrCount -= 1;
                                if (arrCount === 0) {
                                    resolve(args);
                                }
                            }, function (e) {
                                args[index] = { status: 'rejected', reason: e };
                                arrCount -= 1;
                                if (arrCount === 0) {
                                    resolve(args);
                                }
                            });
                        }
                    }
                }
                for (let i = 0; i < args.length; i++) {
                    resolvePromise(i, args[i]);
                }
            });
        };
inWindow() && (window.BuildData = config('build_date'));
export const ignoreLoginPath = noLoginPath;
if (inWindowTool()) {
    window.apiUtils.ignoreLoginPath = ignoreLoginPath;
    window.getSiteModule = getSiteModule;
}
export const isEdm = () => !!profile && profile.includes('edm');
export const isFFMS = () => !!profile && profile.includes('ffmsedm');
export const isWebmail = () => !!profile && profile.startsWith('webmail');
export const isLowMemoryMode = inWindow() ? navigator.userAgent.includes('lx-low-memory-mode') : false;
export const isUseSystemProxy = inWindow() ? !navigator.userAgent.includes('no-system-proxy') : false;
export const defaultSystemProxyType = 'systemProxy-smartProxy';
export const SYSTEM_PROXY_TYPES = ['systemProxy-smartProxy', 'systemProxy-useSystem', 'systemProxy-useDirect'];
export const systemProxyType = inWindow()
    ? SYSTEM_PROXY_TYPES.find(item => navigator.userAgent.indexOf(item) !== -1) || defaultSystemProxyType
    : defaultSystemProxyType;
export const reLoginCodeList = {
    FA_SECURITY: 1,
    FA_INVALID_SESSION: 1,
    FA_UNAUTHORIZED: 1,
    NS_411: 1,
    NF_401: 1,
    NF_403: 1,
    'ERR.SESSIONNULL': 1,
    EXP_AUTH_COOKIE_TIMEOUT: 1,
};
export const supportLocalIndexedDB = () => {
    if (inWindow() && !isElectron() && Date.now() > 2524579200000) {
        return false;
    }
    return true;
};
export const addAccountPageEmailsKey = 'addAccountPageCurrentEmails';
export const MAX_SUB_ACCOUNT_COUNT = 10;
export const addDarkStyle = (isDark) => {
    if (document && localStorage) {
        const isDarkKey = config('LXDarkThemeKey');
        if (isDark) {
            localStorage.setItem(isDarkKey, 'true');
            const darkStyle = document.querySelector('#darkStyle');
            if (!darkStyle) {
                const link = document.createElement('link');
                link.href = config('contextPath') + '/ant-dark-2023-09-18.css';
                link.id = 'darkStyle';
                link.type = 'text/css';
                document.body.appendChild(link);
            }
        }
        else {
            localStorage.setItem(isDarkKey, 'false');
        }
    }
};
if (inWindowTool()) {
    window.addDarkStyle = addDarkStyle;
}
export const getIsInDingTalk = () => (inWindowTool() ? window.isInDingTalk : false);
export const getIsInWxWork = () => (inWindowTool() ? window.isInWxWork : false);
export const getFeiShuUrl = (url) => {
    if (inWindowTool() && window.isInFeiShu && url) {
        const fulUrl = url.indexOf('http') === 0 ? url : `${location.protocol}//${location.host}${url.indexOf('/') === 0 ? url : `/${url}`}`;
        return `https://applink.feishu.cn/client/web_url/open?url=${encodeURIComponent(fulUrl)}&mode=window`;
    }
    return url;
};
export const getDingTalkSearchString = (withAnd, postfixAnd) => (getIsInDingTalk() ? `${withAnd ? '&' : ''}ddtab=true${postfixAnd ? '&' : ''}` : '');
export const addDingTalkSearchStringToUrl = (url) => {
    if (window.isInDingTalk) {
        const hasSearch = url.indexOf('?') !== -1;
        return hasSearch ? `${url}${getDingTalkSearchString(true, false)}` : `${url}?ddtab=true`;
    }
    return url;
};
export const urlStore = {
    get(urlKey) {
        return getUrlNew(urlKey);
    },
};
export const isValidPreviewUrl = (url) => {
    if (!url) {
        return false;
    }
    if (url.indexOf('http') !== 0) {
        return false;
    }
    try {
        const urlInfo = new URL(url);
        const urlHost = urlInfo.host;
        if (location && location.host === urlHost) {
            return true;
        }
        const whiteList = ['163.com', 'netease.com'];
        const inWhiteList = whiteList.some(item => urlHost.indexOf(item) !== -1);
        if (inWhiteList) {
            return true;
        }
        return false;
    }
    catch (ex) {
        return true;
    }
};
export const getCspTag = (cspContent) => {
    if (cspContent && cspContent.length) {
        return '<meta http-equiv="Content-Security-Policy" content="' + cspContent + '" />';
    }
    return '';
};
export const getIsBase64Url = (url) => {
    if (!url || url.length < 10) {
        return false;
    }
    return url.startsWith('data:image/') && url.indexOf(';base64,') > 0;
};
export const getIsPersonalOrgId = (orgId) => {
    if (!orgId || !orgId.length) {
        return false;
    }
    return orgId.startsWith('personal_org_');
};
function comparePinYinStr(pyA, pyB) {
    const maxLen = Math.max(pyA.length, pyB.length);
    for (let i = 0; i < maxLen; i++) {
        const charA = pyA[i];
        const charB = pyB[i];
        if (charA !== charB) {
            if (charA === undefined) {
                return -1;
            }
            if (charB === undefined) {
                return 1;
            }
            if (charA.toLowerCase() !== charB.toLowerCase()) {
                return charA.toLowerCase().localeCompare(charB.toLowerCase());
            }
            return charB.localeCompare(charA);
        }
    }
    return 0;
}
export const compareContactString = (aParam, bParam) => {
    try {
        const a = aParam.toLowerCase();
        const b = bParam.toLowerCase();
        const unWordStartReg = /^[^a-zA-Z]/;
        if (unWordStartReg.test(a) && unWordStartReg.test(b)) {
            const asciiStartReg = /^[\u0000-\u00ff]/;
            if (asciiStartReg.test(a) && asciiStartReg.test(b)) {
                return a.localeCompare(b);
            }
            if (asciiStartReg.test(a)) {
                return -1;
            }
            if (asciiStartReg.test(b)) {
                return 1;
            }
            return a.localeCompare(b);
        }
        if (unWordStartReg.test(a)) {
            return 1;
        }
        if (unWordStartReg.test(b)) {
            return -1;
        }
        return comparePinYinStr(aParam, bParam);
    }
    catch (ex) {
        console.error('compareContactString error:', ex);
        return 0;
    }
};
